import { render } from "./AddEventModal.vue?vue&type=template&id=5cf8ad1c&scoped=true"
import script from "./AddEventModal.vue?vue&type=script&lang=js"
export * from "./AddEventModal.vue?vue&type=script&lang=js"

import "./AddEventModal.vue?vue&type=style&index=0&id=5cf8ad1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf8ad1c"]])

export default __exports__